import { Star, StarHalf, StarBorder } from "@mui/icons-material";
import { Box } from "@mui/material";

const StarRating = ({ rating, onRate }) => {
  const handleClick = (index) => {
    const newRating = rating === index + 1 ? index + 0.5 : index + 1; // Media estrella si ya estaba seleccionada la estrella completa
    onRate(newRating);
  };

  return (
    <Box display="flex" alignItems="center">
      {Array.from({ length: 5 }).map((_, index) => {
        const starValue = index + 1;
        return (
          <Box
            key={index}
            onClick={() => handleClick(index)}
            sx={{ cursor: "pointer", color: "#FFCA28", fontSize: "1.4rem", marginX: "2px" }}
          >
            {rating >= starValue ? (
              <Star fontSize="inherit" />
            ) : rating >= starValue - 0.5 ? (
              <StarHalf fontSize="inherit" />
            ) : (
              <StarBorder fontSize="inherit" />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default StarRating;
